interface Props {
  color?: string
  width?: number
  height?: number
}

export const DeleteIcon = ({ color = '#6F6F6F', width = 21, height = 21 }: Props) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19.4798 0.812805C19.675 0.617608 19.9916 0.617565 20.1868 0.812805C20.382 1.00805 20.382 1.3246 20.1868 1.51984L11.2063 10.4993L20.1868 19.4798C20.3819 19.6751 20.382 19.9916 20.1868 20.1868C19.9916 20.382 19.675 20.3819 19.4798 20.1868L10.4993 11.2064L1.51981 20.1868C1.32457 20.382 1.00802 20.382 0.812775 20.1868C0.617534 19.9916 0.617577 19.6751 0.812775 19.4798L9.79227 10.4993L0.812775 1.51984C0.617513 1.32457 0.617513 1.00807 0.812775 0.812805C1.00804 0.617543 1.32454 0.617543 1.51981 0.812805L10.4993 9.7923L19.4798 0.812805Z"
        fill={color}
      />
    </svg>
  )
}
